module.exports = __webpack_public_path__ + "static/media/smart-search.df97b3ac.svg";